



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import {Device, DeviceConfiguration, DeviceConfigurationSet} from '@/types/core';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import ReadingList from "@/components/ReadingList.vue";

import tippy from 'tippy.js';
import {curDeviceService, DeviceService} from "@/services/DeviceService";
import { curGroupService, GroupConfigurationParameter } from '@/services/GroupService';
import ConfigurationList from "@/components/device/configuration/ConfigurationList.vue";
import * as _ from "lodash";

@Component({
  components:{
    VueError,
    EnterpriseId,
    TimestampAgo,
    ReadingList,
    ConfigurationList
  }
})
export default class DeviceRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) device!: Device;
  @Prop({ default: '',  type: String}) groupId!: string;
  @Prop({ default: false,  type: Boolean}) compareConfigurationSets!: boolean;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: 'deviceId',  type: String}) orderBy!: 'deviceId'|'deviceType'|'lastOnline'|'enterpriseId';
  @Prop({ default: 'asc',  type: String}) ascDesc!: 'asc'|'desc';

  deviceConfigurationDifferent:boolean = false;
  groupConfigurationDifferent:boolean = false;
  currentConfiguration:DeviceConfiguration[] = [];
  // internal dependencies
  private deviceService:DeviceService = curDeviceService;

  async mounted() {
    // nothing yet

    tippy('[data-tippy-content]');

    if (this.bus) {
      this.bus.$on('refresh', async () => {
        this.deviceConfigurationDifferent = await this.isConfigurationSetsDifferent(this.device.deviceId);
        this.groupConfigurationDifferent = await this.isConfigurationSetsDifferent(this.device.deviceId, this.groupId);
        this.currentConfiguration = await this.fetchCurrentConfiguration(this.device.deviceId);
      });
    }

    this.deviceConfigurationDifferent = await this.isConfigurationSetsDifferent(this.device.deviceId);
    this.groupConfigurationDifferent = await this.isConfigurationSetsDifferent(this.device.deviceId, this.groupId);
  }

  toggleOrder(newOrderBy:'deviceId'|'deviceType'|'lastOnline'|'enterpriseId') {
    
    // we are clicking on what we are ordering by already
    if(this.orderBy === newOrderBy)
      return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: this.ascDesc === 'asc' ? 'desc' : 'asc'});

    // we are clicking on another column -> we default to asc
    switch(newOrderBy) {
      case 'deviceId': 
      case 'deviceType': 
      case 'enterpriseId':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'asc'});
      case 'lastOnline': 
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'desc'});
    }
  }

  async fetchCurrentConfiguration(deviceId:string):Promise<DeviceConfiguration[]> {
    try {
      const configurationSet: DeviceConfigurationSet = await this.deviceService.loadDeviceConfiguration({
        deviceId,
      }) as DeviceConfigurationSet;
      return configurationSet.current;
    } catch (err) {
      console.log(err);
      return Promise.reject(err);
    }
  }

  getStatus():string {
    if (this.groupConfigurationDifferent) {
      return 'device and group configurations are different';
    } else if (this.deviceConfigurationDifferent) {
      return 'device configuration is in progress...';
    } else {
      return 'configuration applied successfully';
    }
  }

  async isConfigurationSetsDifferent(
    deviceId: string,
    groupId?: string
  ): Promise<boolean> {
    if (this.compareConfigurationSets) {
      try {
        const configurationSet:DeviceConfigurationSet = await this.deviceService.loadDeviceConfiguration({
          deviceId,
        }) as DeviceConfigurationSet;

        let newConf: Partial<DeviceConfiguration>[];

        if (groupId) {
          newConf = await curGroupService.loadGroupConfiguration({ 
            groupId: this.groupId 
          }) as GroupConfigurationParameter[];
        } else {
          newConf = configurationSet.newConf as DeviceConfiguration[];
        }

        if (!newConf) {
          return false;
        }
        // Assumption: newConf is full with all the parameters from the device profile.
        // The update configuration needs to be fired to satisfy this assumption.
        return !newConf.every(param => {
          const relatedParamInCurrentConf = configurationSet.current.find(currentParam => currentParam.id === param.id);
          if (!relatedParamInCurrentConf) {
            return false;
          }
          if ( Array.isArray(param.value) ) {
            param.value = _.sortBy(param.value);
          }
          if ( Array.isArray(relatedParamInCurrentConf.value) ) {
            relatedParamInCurrentConf.value = _.sortBy(relatedParamInCurrentConf.value);
          }
          const eq = _.isEqual(param.value, relatedParamInCurrentConf.value);
          if ( !eq ) {
            // DEBUG INFO
            // console.log(`id: ${param.id}, current: ${relatedParamInCurrentConf.value}, group value: ${param.value}`);
          }
          return eq;
        });
      } catch (err) {
        console.log(err);
        return true;
      }
    }
    return false;
  }

  goToDevicePage(deviceId:string) {
    this.$router.push(`/assets/devices/${deviceId}`);
  }

  get isConfigDifferent() {
    return this.deviceConfigurationDifferent || this.groupConfigurationDifferent;
  }
}

